import { API_URLS } from '@helpers/api';
import { withQueryParams } from '@hoc/withQueryParams';
import { useApi } from '@hooks/useApi';
import NewsCard from '@stories/Components/Cards/NewsCard/NewsCard';
import FilteredListing from '@stories/Components/FilteredListing/FilteredListing';
import queryString from 'query-string';
import React from 'react';
import { useFirstMountState } from 'react-use';
import { BooleanParam, NumberParam, StringParam, useQueryParams } from 'use-query-params';
import S from './NewsListing.styles';
const NewsListing = ({ pageContext, favourites = false, filterAlignment = 'center', filterTheme = 'lightGrey', filterTitle, initialData, searchTerm = '', sectorFilter, sortByOptions, tailored = false, topicFilter, typeFilter, errorText, }) => {
    const isFirstMount = useFirstMountState();
    // Define query string parameters.
    const [queryParams, setQueryParams] = useQueryParams({
        favourites: BooleanParam,
        pageIndex: NumberParam,
        sector: StringParam,
        sortBy: StringParam,
        tailored: BooleanParam,
        topic: StringParam,
        type: StringParam,
    });
    // Create filter value structure.
    const filterValue = {
        sector: queryParams.sector ?? '',
        topic: queryParams.topic ?? '',
        type: queryParams.type ?? '',
    };
    // Get page index or default.
    const pageIndex = queryParams.pageIndex ?? 1;
    // Get sort by or default.
    const sortByValue = queryParams.sortBy ?? sortByOptions[0].value;
    // Construct API url.
    const parameters = queryString.stringify({
        docId: pageContext?.documentId,
        favourites: favourites,
        pageIndex: pageIndex,
        pageSize: 24,
        searchTerm: searchTerm,
        sector: filterValue.sector,
        tailored: tailored,
        topic: filterValue.topic,
        type: filterValue.type,
        sortBy: sortByValue,
    });
    const apiUrl = `${API_URLS.news}?${parameters}`;
    // Fetch data.
    const { data, loading, error } = useApi(apiUrl, !isFirstMount);
    // Get items from response or initial items.
    const items = data?.items ?? initialData.items;
    const totalItems = data?.totalItems ?? initialData.totalItems;
    return (React.createElement(FilteredListing, { errorText: errorText, error: error, filtersProps: {
            alignment: filterAlignment,
            filters: [typeFilter, topicFilter, sectorFilter],
            filterTheme: filterTheme,
            filterValue: filterValue,
            sortByOptions: sortByOptions,
            sortByValue: sortByValue,
            title: filterTitle,
            onFilterChange: (key, val) => setQueryParams({ [key]: val, pageIndex: 1 }),
            onSortChange: (val) => setQueryParams({ sortBy: val, pageIndex: 1 }),
        }, items: items, loading: loading, pageIndex: pageIndex, renderItems: (items) => (React.createElement(S.ItemList, null, items.map((item) => (React.createElement(S.Item, { key: item.id },
            React.createElement(NewsCard, { isLoggedIn: pageContext?.isLoggedIn, ...item })))))), totalItems: totalItems, onPageChange: (pageIndex) => {
            setQueryParams({ pageIndex });
        } }));
};
export default withQueryParams(NewsListing);
